import { useState } from "react";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import {
    StyledEmptyText,
    StyledAddButtonContainer,
} from "app/pages/sales-intelligence/modules/apps-search-filters/components/filters/AppAdSellersFilter/styles";
import AdsSellersModal from "app/pages/sales-intelligence/modules/apps-search-filters/components/modals/AdsSellersModal/AdsSellersModal";
import type { IAppsAdSellersFilterItem } from "app/pages/sales-intelligence/store/find-apps/types";

import type FindAppsAdsSellersFilter from "../../../models/AdsSellersFilter/AdsSellersFilter";

const AppAdSellersFilter = ({
    filter: { options },
    value = [],
    onFilterUpdate,
}: IFilterViewBaseProps<FindAppsAdsSellersFilter>) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const handleOpenModal = () => {
        setIsOpenModal(true);
    };

    const renderAddButton = () => {
        const button = (
            <IconButton
                type="flat"
                iconName="add"
                onClick={handleOpenModal}
                dataAutomation="ads-sellers-filter-button-add"
            >
                {translate(`si.find_apps.filters.ads_sellers.button.add`)}
            </IconButton>
        );

        if (value && value?.length > 0) {
            return (
                <Tooltip content={translate(`si.find_apps.filters.ads_sellers.button.add.tooltip`)}>
                    <div>{button}</div>
                </Tooltip>
            );
        }

        return button;
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IAppsAdSellersFilterItem) => {
        onFilterUpdate(value ? [...value, item] : [item]);
        setIsOpenModal(false);
    };

    return (
        <>
            <AdsSellersModal
                isOpen={isOpenModal}
                selected={null}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
                options={options}
                value={value}
            />
            {!(value?.length > 0) ? (
                <StyledEmptyText>{translate(`si.find_apps.filters.ads_sellers.empty_text`)}</StyledEmptyText>
            ) : null}
            <StyledAddButtonContainer>{renderAddButton()}</StyledAddButtonContainer>
        </>
    );
};

export default AppAdSellersFilter;
